import React, { useState } from "react";
import API from "../../services/API"; // Adjust as needed.
import baseElementTemplate from "../../data/baseElement.json";
import UploadElementDialog from "./UploadElementDialog";
import { v4 as uuidv4 } from 'uuid'; // Import the uuid function
import { AppButton } from "../ui";

const NewElementUploader = ({ onNewElementCreated, initialElementId, initialElementData }) => {
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setUploadDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setUploadDialogOpen(false);
  };

  // Helper function to get image dimensions from a File object.
  const getImageDimensions = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = (err) => reject(err);
      const reader = new FileReader();
      reader.onload = (e) => {
        img.src = e.target.result;
      };
      reader.onerror = (err) => reject(err);
      reader.readAsDataURL(file);
    });
  };

  const handleUpload = async ({ name, description, file }) => {
    // Merge initial data over template so required nested fields exist.
    const newElementPayload = initialElementData
      ? {
          ...baseElementTemplate,
          ...initialElementData,
          labelData: {
            ...baseElementTemplate.labelData,
            ...initialElementData.labelData,
          },
          visualizerData: {
            ...baseElementTemplate.visualizerData,
            ...initialElementData.visualizerData,
          },
          worldUnit: {
            ...baseElementTemplate.worldUnit,
            ...initialElementData.worldUnit,
          },
        }
      : { ...baseElementTemplate };

    const elementId = initialElementId || newElementPayload.id || uuidv4();
    newElementPayload.id = newElementPayload.dataObjectID = elementId;

    if (name && name.trim()) {
      newElementPayload.labelData.displayName = name.trim();
    }
    if (description && description.trim()) {
      newElementPayload.labelData.description = description.trim();
    }
    newElementPayload.fileName = file.name;

    const fileExtension = file.name.split(".").pop().toLowerCase();

    switch (fileExtension) {
      case "png":
      case "jpg":
      case "jpeg":
        newElementPayload.visualizerData.dataType = 1;
        newElementPayload.visualizerData.visualizationType = 3;
        newElementPayload.visualizerData.defaultMaterialName =
          "DefaultSpriteMaterial";
        newElementPayload.worldUnit.value = 40;

        try {
          const { width, height } = await getImageDimensions(file);
          newElementPayload.visualizerData.xValue = height / width;
        } catch (err) {
          console.error("Failed to get image dimensions:", err);
        }
        break;
      case "obj":
      case "fbx":
      case "glb":
      case "gltf":
         newElementPayload.visualizerData.dataType = 4;
        newElementPayload.visualizerData.visualizationType = 2;
        break;
        case "swc":
        newElementPayload.visualizerData.dataType = 4;
        newElementPayload.visualizerData.visualizationType = 2;
        newElementPayload.worldUnit.value = 1;
        newElementPayload.worldUnit.units = 4;


        break;
      case "pdb":
        newElementPayload.visualizerData.dataType = 1;
        newElementPayload.visualizerData.visualizationType = 6;
        newElementPayload.worldUnit.value = 1;
        newElementPayload.worldUnit.units = 2;
        break;
      default:
        // Fallback for unknown file types.
        break;
    }

    try {
      const response = await API.post("elements/", newElementPayload, {
        requiresAuth: true,
      });
      // Expecting a presigned URL in the response.
      const { sourceUploadUrl } = response.data.data;
      console.log("SOURCE URL", sourceUploadUrl);
      if (file && sourceUploadUrl) {
        await fetch(sourceUploadUrl, {
          method: "PUT",
          body: file,
          headers: { "Content-Type": file.type },
        });
      }



      const buildResponse = await API.post("build-element", newElementPayload, {
        requiresAuth: true,
      });

      console.log(buildResponse);

      // Call parent's callback, if provided, to update the list.
      if (onNewElementCreated && !initialElementId) {
        onNewElementCreated({
          id: newElementPayload.id,
          name: newElementPayload.labelData.displayName,
          description: newElementPayload.labelData.description,
        });
      }
      handleCloseDialog();
    } catch (error) {
      console.error("Error uploading new element:", error);
    }
  };

  return (
    <>
      <AppButton onClick={handleOpenDialog}>
        Upload New Element
      </AppButton>
      <UploadElementDialog
        open={uploadDialogOpen}
        onClose={handleCloseDialog}
        onUpload={handleUpload}
      />
    </>
  );
};

export default NewElementUploader;
